module.exports = __webpack_public_path__ + "img/static-job1@2x.ab1ed999.png";